import React from 'react'
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import './WidgetView.css';
import { HeroViewButton } from '../ButtonTheme';

function copyCode(codeToCopy) {
    navigator.clipboard.writeText(codeToCopy)
        .then(() => {
            alert('Code copied to clipboard!');
        })
        .catch((error) => {
            console.error('Error copying code: ', error);
        });
}


function WidgetView() {

    const scriptImportCode = `
        <script src="https://dfv2bs0cn166o.cloudfront.net/script.min.js"></script>
    `;

    const newDivCode = `
        <div id='blankwall-container'></div>
    `;

    const newDivJsCode = `
        <script>
            var targetElement = document.getElementsByClassName('target-element-class')[0];
            var containerElement = document.createElement('div');
            containerElement.id = 'blankwall-container';
            targetElement.parentNode.insertBefore(containerElement, targetElement.nextSibling);
        </script>
    `;

    const initCode = `
        <script>
            BlankWallWidget.init({
                ar_image_element_class: 'ProductItem-gallery-slides-item-image',
                ar_dimensions_element_class: 'ProductItem-details-excerpt',
            }, 'blankwall-container');
        </script>
    `;

    return (
        <div className='Widget'>
            <Container className='widget-container' maxWidth="lg">
                
                <Grid className='widget-main-title-grid' item xs={12} xl={12} sm={12} md={12}>
                    <h1 className='widget-main-title'>Integrate <span className="widget-gradient-text">Blankwall</span> with any site.</h1>
                    <div className="widget-divider">
                        <div className="widget-divider-line"></div>
                    </div>
                </Grid>

                <Grid className='widget-steps-container' item xs={12} xl={12} sm={12} md={12}>
                    <h2 className='widget-step-title'>01 Load the Blankwall script</h2>
                    <div className="widget-code-container">
                        <div className="widget-code-header">
                            <IconButton
                                sx={{ fontSize: '14px'}}
                                className="widget-copy-button" 
                                onClick={() => copyCode(scriptImportCode)}
                                size="small"
                            >
                                <ContentCopyIcon sx={{fontSize: 'medium'}} />Copy Code
                            </IconButton>
                        </div>
                        <div className="widget-code-content">
                            <pre>
                                <code>
                                    {scriptImportCode}
                                </code>
                            </pre>
                        </div>
                    </div>
                    <div className="widget-divider">
                        <div className="widget-divider-line"></div>
                    </div>
                </Grid>

                <Grid className='widget-steps-container' item xs={12} xl={12} sm={12} md={12}>
                    <h2 className='widget-step-title'>02 Create a container for the AR button</h2>
                    <h3 className='widget-step-subtitle'>Using HTML</h3>
                    <p className='widget-step-content'>Insert directly in the DOM where you want the button to be displayed.</p>
                    <div className="widget-code-container">
                        <div className="widget-code-header">
                            <IconButton
                                sx={{ fontSize: '14px'}}
                                className="widget-copy-button" 
                                onClick={() => copyCode(newDivCode)}
                                size="small"
                            >
                                    <ContentCopyIcon sx={{fontSize: 'medium'}} />Copy Code
                            </IconButton>
                        </div>
                        <div className="widget-code-content">
                            <pre>
                                <code>
                                    { newDivCode }
                                </code>
                            </pre>
                        </div>
                    </div>
                    <h3 className='widget-step-subtitle'>Using Javascript</h3>
                    <p className='widget-step-content'>Position the container relative to another element.</p>
                    <div className="widget-code-container">
                        <div className="widget-code-header">
                            <IconButton
                                sx={{ fontSize: '14px'}}
                                className="widget-copy-button" 
                                onClick={() => copyCode(newDivJsCode)}
                                size="small"
                            >
                                    <ContentCopyIcon sx={{fontSize: 'medium'}} />Copy Code
                            </IconButton>
                        </div>
                        <div className="widget-code-content">
                            <pre>
                                <code>
                                    { newDivJsCode }
                                </code>
                            </pre>
                        </div>
                    </div>
                    <div className="widget-divider">
                        <div className="widget-divider-line"></div>
                    </div>
                </Grid>

                <Grid className='widget-steps-container' item xs={12} xl={12} sm={12} md={12}>
                    <h2 className='widget-step-title'>03 Initialize the widget</h2>
                    <div className="widget-code-container">
                        <div className="widget-code-header">
                            <IconButton
                                sx={{ fontSize: '14px'}}
                                    className="widget-copy-button" 
                                    onClick={() => copyCode(initCode)}
                                    size="small"
                                >
                                    <ContentCopyIcon sx={{fontSize: 'medium'}} />Copy Code
                            </IconButton>
                        </div>
                        <div className="widget-code-content">
                            <pre>
                                <code>
                                    { initCode }
                                </code>
                            </pre>
                        </div>
                    </div>
                    <p className='widget-step-content'>The first argument of the init function takes two properties:</p>
                    <ol className='widget-step-list-container'>
                        <li className='widget-step-list-content'>
                            <b>ar_image_element_class</b> : The class name of the element containing the image you want to use for AR.
                        </li>
                        <li className='widget-step-list-content'>
                            <b>ar_dimensions_element_class</b> : The class name of the element containing the dimensions of the asset in plain text.
                        </li>
                    </ol>
                    <p className='widget-step-content'>The second argument of the init function is used to pass in the ID of the container element created above.</p>
                    <div className="widget-divider">
                        <div className="widget-divider-line"></div>
                    </div>
                </Grid>

                <Grid item xs={12} xl={12} sm={12} md={12}>
                    <h2 className='widget-help-title'>
                        Need help?
                    </h2>
                    <HeroViewButton sx={{marginLeft: '2rem'}} href="/contact">Talk to Dev</HeroViewButton>
                </Grid>

            </Container>
        </div>
    )

}

export default WidgetView;
